import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { Periode, CreatePeriodeRequest, UpdatePeriodeRequest } from '@/shared/types/admin'

export const periodesApi = {
  getAll: () =>
    api.get<ApiResponse<Periode[]>>('/api/periodes').then((r) => r.data.data),

  getById: (id: number) =>
    api.get<ApiResponse<Periode>>(`/api/periodes/${id}`).then((r) => r.data.data),

  getActifs: () =>
    api.get<ApiResponse<Periode[]>>('/api/periodes/actifs').then((r) => r.data.data),

  create: (data: CreatePeriodeRequest) =>
    api.post<ApiResponse<Periode>>('/api/periodes', data).then((r) => r.data.data),

  update: (id: number, data: UpdatePeriodeRequest) =>
    api.put<ApiResponse<Periode>>(`/api/periodes/${id}`, data).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/periodes/${id}`),
}
